import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/DeleteAccount.css";

const DeleteAccount = () => {
  const navigate = useNavigate();
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState(null);
  const [password, setPassword] = useState("");
  const [showModal, setShowModal] = useState(false);

  const handleDelete = () => {
    setShowModal(true);
  };

  const handleConfirmDelete = async () => {
    if (!password) {
      setError("Please enter your password.");
      return;
    }

    setIsDeleting(true);
    setError(null);

    try {
      const userId = sessionStorage.getItem("user");
      const token = sessionStorage.getItem("token");
      const verifyResponse = await fetch(`${process.env.REACT_APP_API_PATH}/auth/verify`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ password: password }),
      });

      if (!verifyResponse.ok) {
        throw new Error("Incorrect password. Please try again.");
      }
      const deleteResponse = await fetch(`${process.env.REACT_APP_API_PATH}/users/${userId}?relatedObjectsAction=delete`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!deleteResponse.ok) {
        throw new Error("Failed to delete account. Please try again.");
      }

      sessionStorage.clear();
      alert("Your account has been deleted.");
      navigate("/");
    } catch (error) {
      setError(error.message);
    } finally {
      setIsDeleting(false);
      setShowModal(false);
    }
  };

  return (
    <div className="delete-account-container">
      <div className="sad-face">😢</div>
      <h2>We will miss you very much</h2>

      {error && <p className="error-message">Error: {error}</p>}

      <button className="go-back-button" onClick={() => navigate(-1)}>Go Back!</button>
      <button className="delete-button" onClick={handleDelete} disabled={isDeleting}>
        {isDeleting ? "Deleting..." : "Delete your account"}
      </button>
      {showModal && (
        <div className="modal">
          <div className="modal-content">
            <h3>Confirm Account Deletion</h3>
            <p>Enter your password to confirm:</p>
            <input 
              type="password" 
              placeholder="Enter password" 
              value={password} 
              onChange={(e) => setPassword(e.target.value)}
              className="password-input"
            />
            {error && <p className="error-message">{error}</p>}
            <div className="modal-buttons">
              <button className="confirm-button" onClick={handleConfirmDelete} disabled={isDeleting}>
                {isDeleting ? "Deleting..." : "Confirm"}
              </button>
              <button className="cancel-button" onClick={() => setShowModal(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DeleteAccount;